export class ApiError extends Error {
  constructor(
    message: string,
    readonly status: number,
    readonly code: string,
  ) {
    super(message)
    this.name = "ApiError"
  }
}

export async function apiRequest<T>(
  path: string,
  init: RequestInit & { idempotent?: boolean } = {},
): Promise<T> {
  const headers = new Headers(init.headers)
  headers.set("accept", "application/json")
  if (init.body && !headers.has("content-type")) headers.set("content-type", "application/json")
  if (init.idempotent && !headers.has("idempotency-key")) {
    headers.set("idempotency-key", crypto.randomUUID())
  }
  const response = await fetch(path, {
    ...init,
    headers,
    credentials: "same-origin",
  })
  const payload = (await response.json().catch(() => null)) as
    | T
    | { error?: { code?: string; message?: string } }
    | null
  if (!response.ok) {
    const error =
      payload && typeof payload === "object" && "error" in payload ? payload.error : undefined
    throw new ApiError(
      error?.message ?? "Resolto could not complete the request.",
      response.status,
      error?.code ?? "REQUEST_FAILED",
    )
  }
  return payload as T
}
